import i18n from "../i18n/i18n";

/**
 * Returns a product/item name in the currently selected language.
 * New products are stored by the backend as {en, hi, te}.
 * Old rows that still contain a plain string safely fall back to that string.
 */
export function getLocalizedName(name) {
  if (!name) return "";
  if (typeof name === "string") {
    try {
      const parsed = JSON.parse(name);
      if (parsed && typeof parsed === "object") name = parsed;
      else return name;
    } catch {
      return name;
    }
  }
  const lang = (i18n.language || "en").split("-")[0];
  return name?.[lang] || name?.en || name?.hi || name?.te || Object.values(name)[0] || "";
}

export function getLocalizedCategory(category, t) {
  const key = {
    vegetables: "categories.vegetables",
    flowers: "categories.flowers",
    garland: "categories.garland",
    courier: "categories.courier",
    accessories: "categories.accessories",
  }[String(category || "").toLowerCase()];
  return key ? t(key) : category || "";
}
